// The version of the application as the day and the time it was built, in Finnish time,
// e.g. { date: "15.10.2026", time: "11.02" }; null when not known
const formatAppVersion = (
  builtAt: null | string | undefined
): null | { date: string; time: string } => {
  if (!builtAt) {
    return null;
  }

  // The time comes as UTC; a time without a zone is UTC too
  const time = new Date(
    /[zZ]|[+-]\d\d:?\d\d$/.test(builtAt) ? builtAt : `${builtAt}Z`
  );
  if (Number.isNaN(time.getTime())) {
    return null;
  }

  return {
    date: time.toLocaleDateString('fi-FI', { timeZone: 'Europe/Helsinki' }),
    time: time.toLocaleTimeString('fi-FI', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Helsinki',
    }),
  };
};

export default formatAppVersion;
